import React from 'react';

const icons = {
    editIcon: "/icons/edit.svg",
    detailIcon: "/icons/detail.svg",
    timesIcon: "/icons/times.svg"
}

export default function RonadIcons (props: {name:string, title?: string}) {
    return (
        <span style={{padding: "5px" }} title={props.title}>
            <img src={icons[props.name]} alt={props.name} width="20px" height="20px"/>
        </span>
    )
}